import React from 'react';
import PieGraph from './pieGraph.js';
import BarChartWithPreamble from './BarChartWithPreamble.js';
import DisplayTotalTime from './totalTime.js';
import { Box } from 'bloomer/lib/elements/Box';
import { Title } from 'bloomer/lib/elements/Title';
import Bold from '../Bold';
import { Section } from 'bloomer/lib/layout/Section';

export default function GeneralDataBreakdown({
	startDate,
	endDate,
	totalTime,
	data,
	animalType
}) {
	return (
		<Box className="on-print-own-page">
			<Title tag="h3">General Breakdown:</Title>
			<Section>
				<DisplayTotalTime
					totalTime={totalTime}
					startDate={startDate}
					endDate={endDate}
					animalType={animalType}
				/>
				<p>
					The breakdown of enrichment by type between{' '}
					<Bold>{startDate}</Bold> and{' '}
					<Bold>{endDate}</Bold> is as follows:
				</p>

				<PieGraph totalTime={totalTime} data={data} />
			</Section>
			<Section>
				<BarChartWithPreamble data={data} totalTime={totalTime} animalType={animalType} />
			</Section>
		</Box>
	);
}
